import * as React from "react";
import { TTranslate } from "../../../service/locale/TranslationService";
import { FormComponentProps } from "antd/lib/form";
import MenuItemForm from "./MenuItemForm";
import { IMenuItem } from "../../../model/menu/MenuItem";

export interface State {}

export interface CreateMenuItemFormProps extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
  codebooks: IMenuItem[];
}

class CreateMenuItemForm extends React.Component<
  CreateMenuItemFormProps,
  State
> {
  componentDidMount() {
    const { registerFormSubmitEventHandler } = this.props;
    registerFormSubmitEventHandler(e => {
      e.preventDefault();
      let newMenuItem = null;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          newMenuItem = values;
        }
      });
      return newMenuItem;
    });
  }

  render() {
    const { translate, codebooks } = this.props;

    const { getFieldDecorator, getFieldValue, resetFields } = this.props.form;

    return (
      <MenuItemForm
        getFieldDecorator={getFieldDecorator}
        translate={translate}
        codebooks={codebooks}
        resetFields={resetFields}
        getFieldValue={getFieldValue}
      />
    );
  }
}

export default CreateMenuItemForm;
